import styled from 'styled-components';

export const WaveWrapper = styled.div`
  color: var(--color-fixed-tint);
  padding: 0 40px 40px;

  svg {
    margin: 0 auto;
  }
`;
